<span class="label-with-id">
  <span *ngIf="ID !== null && ID !== undefined && IDPosition === IDPositionOptions.Before"
    class="before">
    {{ IDPrefix }}{{ ID }}
  </span>
  <span class="label-with-id__label">
    {{ label }}
  </span>
  <span *ngIf="ID !== null && ID !== undefined && IDPosition === IDPositionOptions.After"
    class="after">
    ({{ IDPrefix }}{{ ID }})
  </span>
</span>
